// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DelG","type":"styles_type__3TN_T","choices":"styles_choices__21dfh"};